var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCryptoOrg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.953 0L0 7.517v14.966L12.953 30l12.953-7.517V7.517L12.953 0zm9.128 20.268l-9.128 5.235-9.127-5.235V9.732l9.127-5.302 9.128 5.302v10.537z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.06 18.456l-6.108 3.49-6.04-3.49v-6.98l6.04-3.49 6.108 3.49v6.98z",
    fill: "#fff"
  })));
}

export default SvgCryptoOrg;